// Decorative avatar tints for the discovery card's attendee counter.
// Deterministic per seed so cards don't reshuffle between renders.
// The circles are intentionally identity-free: the events payload only
// carries an attendee COUNT, not who is attending.
//
// TODO(member-profiles): swap these for real member avatars once public
// member profiles land (members get an auto-generated avatar they can
// override, earning Path Coins for personalising it).

// Path Collective visual system: hero yellow, support teal, accent terracotta
const AVATAR_TINTS: { from: string; to: string }[] = [
  { from: "#F0B853", to: "#F3DFBE" },
  { from: "#75A096", to: "#D4D9CE" },
  { from: "#DE866D", to: "#EFD3C4" },
  { from: "#F1C577", to: "#FFFDF8" },
  { from: "#95B3A9", to: "#FFFDF8" },
  { from: "#E4A08A", to: "#FFFDF8" },
]

export function hashSeed(seed: string): number {
  let h = 0
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) | 0
  }
  return Math.abs(h)
}

export function avatarGradient(seed: string, index = 0): { from: string; to: string } {
  return AVATAR_TINTS[(hashSeed(seed) + index) % AVATAR_TINTS.length]!
}
